import React from "react";
// T2/100A284: sin uso (el logo es local). Antes: import { CDN } from "Constants";
import dayjs from "dayjs";
import IvaPleno from "./IvaPleno";
import Aiu from "./Aiu";
import { formatMoney, getCostItem, getUnitCost } from "../Utili";
import "./reporte.css";

// ---------------------------------------------------------------------------
// CotizacionDocumento — the printable content of a Cotización, extracted
// verbatim from CotizacionDetalle's "detail" tab (the same JSX previously
// captured by html2canvas via `componentRef` — see git history for
// capturePdfBase64.js). Extracted so the /print/cotizacion/:id page (read
// by jag-backend's Puppeteer PDF route) and the interactive Drawer render
// IDENTICAL markup — guaranteed visual parity, no reimplemented layout.
//
// Pure presentational component: owns no state, fetches nothing. Callers
// supply the already-loaded `doc` (cotización) and `empresa` (config-site)
// data.
// ---------------------------------------------------------------------------

const renderItem = (a, doc) => {
  if (!a) {
    return null;
  }

  if (a?.tipo == 0 || a?.tipo == null) {
    return (
      <tr key={a?._id} className="cotizacion-category-row">
        <td
          colSpan={6}
          style={{ position: "sticky", top: 0, backgroundColor: "#ebe8e8" }}
        >
          <h2>{a?.descripcion}</h2>
        </td>
      </tr>
    );
  }

  return (
    <tr key={a._id} className="cotizacion-item-row">
      <td>{a?.descripcion}</td>

      <td align="center">{a?.unidad}</td>
      <td align="center">{a?.cantidad}</td>
      {doc.tipo == "M" ? <td>{a?.frecuencia}</td> : ""}
      <td align="right" width={150}>
        <span style={{ fontSize: 20, fontWeight: 500 }}>
          ${formatMoney(getUnitCost(a))}
        </span>
      </td>
      <td align="right" width={150}>
        <span style={{ fontSize: 20, fontWeight: 500 }}>
          ${formatMoney(getCostItem(a, doc.tipo))}
        </span>
      </td>
    </tr>
  );
};

const CotizacionDocumento = React.forwardRef(({ doc = {}, empresa = {} }, ref) => {
  return (
    <div
      style={{
        zIndex: 99,
        position: "relative",
        padding: "10mm",
        paddingBottom: 24,
        backgroundColor: "#fff",
      }}
      className="reporte"
      ref={ref}
    >
      <table
        width="100%"
        style={{
          marginBottom: 16,
          position: "relative",
          zIndex: 99,
        }}
        className="report-table cotizacion-header-block"
      >
        <tr>
          <td colSpan={2}>
            {/* T2/100A284: logo local del frontend (el mismo de la barra: public/logo/logo_remove_bg.png,
                components/Navbar.js:34). Con la copia local el CDN no tiene el archivo y no cargaba; regla:
                las imágenes no dependen de carga remota. Antes:
                src={`${CDN}/website/logo_color.png?t=${Date.now()}`} */}
            <img
              width="30%"
              style={{ marginBottom: 16 }}
              src={`${process.env.PUBLIC_URL || ""}/logo/logo_remove_bg.png`}
              alt="Logo JAG Ingeniería y Refrigeración"
            />
          </td>
        </tr>
        <tr>
          <td valign="top" width={"50%"}>
            <table style={{ border: "1px solid #000" }} width={"70%"}>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Nombre
                </th>
                <td style={{ padding: 1 }}>{empresa?.nombre}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  NIT
                </th>
                <td style={{ padding: 1 }}>{empresa?.nit}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Ciudad
                </th>
                <td style={{ padding: 1 }}>{empresa?.ciudad}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Dirección
                </th>
                <td style={{ padding: 1 }}>{empresa?.dir}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Teléfono
                </th>
                <td style={{ padding: 1 }}>{empresa?.tel}</td>
              </tr>
            </table>

            <b>
              <br></br>
              COT {doc?.fullCode}
            </b>
          </td>
          <td width={"50%"} valign="top">
            <table style={{ border: "1px solid #000" }} width={"100%"}>
              <tr>
                <th
                  colSpan={2}
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Datos del cliente
                </th>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Cliente
                </th>
                <td style={{ padding: 1 }}>{doc?.cliente?.name}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Sucursal
                </th>
                <td style={{ padding: 1 }}>{doc?.sucursal?.name}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Email
                </th>
                <td style={{ padding: 1 }}>{doc?.sucursal?.email}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Dirección
                </th>
                <td style={{ padding: 1 }}>{doc?.sucursal?.address}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Teléfono
                </th>
                <td style={{ padding: 1 }}>{doc?.sucursal?.telephone}</td>
              </tr>
              <tr>
                <th
                  align="left"
                  style={{
                    backgroundColor: "#1651aa",
                    padding: 1,
                    color: "#ffff",
                  }}
                >
                  Fecha presupuesto
                </th>
                <td style={{ padding: 1 }}>
                  {dayjs.utc(doc?.fecha).format("DD-MMM-YY")}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <br></br>
      <table width="100%" className="report-table items">
        <tr>
          <th
            style={{
              backgroundColor: "#1651aa",
              color: "#ffff",
            }}
          >
            Descripción
          </th>

          <th
            style={{
              backgroundColor: "#1651aa",
              color: "#ffff",
            }}
          >
            Unidad
          </th>
          <th
            style={{
              backgroundColor: "#1651aa",
              color: "#ffff",
            }}
          >
            Cant.
          </th>
          {doc?.tipo == "M" && (
            <th
              style={{
                backgroundColor: "#1651aa",
                color: "#ffff",
              }}
            >
              Frecuencia
            </th>
          )}
          <th
            style={{
              backgroundColor: "#1651aa",
              color: "#ffff",
            }}
          >
            Valor unitario
          </th>
          <th
            style={{
              backgroundColor: "#1651aa",
              color: "#ffff",
            }}
          >
            Total
          </th>
        </tr>
        <tbody>{doc?.articulos?.map((a) => renderItem(a, doc))}</tbody>
        {doc?.modo == 1 ? <IvaPleno doc={doc} /> : null}

        {doc?.modo == 2 ? <Aiu doc={doc} /> : null}
      </table>

      <table width="100%" className="report-table cotizacion-signature-block">
        <tr>
          <td width={"25%"} valign="bottom">
            <table width={"100%"}>
              <tr>
                <th style={{ background: "silver" }}></th>
              </tr>
              <tr>
                <td style={{ borderTop: "1px solid silver" }} align="center">
                  {doc?.creadoPor?.signature && (
                    <img
                      src={doc.creadoPor.signature}
                      alt="Firma"
                      style={{ maxHeight: 50, display: "block", margin: "0 auto" }}
                    />
                  )}
                  {doc?.creadoPor?.name}
                </td>
              </tr>
            </table>
          </td>
          <td width={"50%"} valign="bottom">
            <table width={"100%"}>
              <tr>
                <th style={{ background: "silver" }}>Observaciones</th>
              </tr>
              <tr>
                <td>
                  <p
                    style={{ fontSize: 12 }}
                    dangerouslySetInnerHTML={{
                      __html: doc?.obs?.replace(/\n/g, "</br>"),
                    }}
                  ></p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  );
});

export default CotizacionDocumento;
